import { render, staticRenderFns } from "./lista.vue?vue&type=template&id=f236f3fc&scoped=true&"
import script from "./lista.vue?vue&type=script&lang=js&"
export * from "./lista.vue?vue&type=script&lang=js&"
import style0 from "./lista.vue?vue&type=style&index=0&id=f236f3fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f236f3fc",
  null
  
)

export default component.exports